"use client";

import React from "react";
import { ArrowRight, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicBusinessShield() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="26" id="textcontent" className="dark bg-background text-foreground relative overflow-hidden py-12 lg:py-24">
      <style dangerouslySetInnerHTML={{
      __html: `
        .article-title, .article-preview-title {
          font-family: var(--font-sans) !important;
        }
      `
    }} />
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-primary/2 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-64 h-64 bg-primary/4 rounded-full blur-3xl pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-32 items-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="flex flex-col justify-center space-y-8 max-w-2xl px-4 lg:px-0">
          <div className="space-y-6">
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-tight text-foreground">
  <span className="text-primary italic">
    <span className="block font-sans font-normal text-3xl sm:text-5xl md:text-6xl text-[#f8fafc] not-italic antialiased">
      DIRITTO CIVILE E CONTRATTUALISTICA
    </span>
  </span>
</h1>

            
            <p className="font-sans text-lg text-muted-foreground leading-relaxed max-w-lg !text-justify md:text-xl">Lo Studio DCLegal offre ai propri clienti assistenza continuativa su numerose problematiche di diritto civile ed in particolare in merito alla contrattualistica d’impresa assistendo i clienti nelle diverse fasi di negoziazione, redazione, revisione ed esecuzione di contratti e accordi commerciali. L’esperienza acquisita dai professionisti di DCLegal permette al cliente di essere assistito in merito contratti di distribuzione, agenzia, franchising, consulenza, contratti di appalto, sub-fornitura, compravendita di beni mobili e condizioni generali di vendita, contratti di locazione e di compravendita immobiliare nonché accordi di collaborazione tra società e operazioni societarie.</p>
          </div>

          
          
          {}
          
        </div>

        {}
        <div className="relative lg:h-auto flex justify-center lg:justify-end">
          <div className="relative w-full max-w-md lg:max-w-lg aspect-[3/4] lg:aspect-[4/5]">
            {}
            <div className="absolute top-6 right-6 w-full h-full bg-card/40 backdrop-blur-md rounded-2xl -z-10 border border-primary/10 shadow-2xl" />
            
            {}
            <div className="absolute -bottom-4 -left-4 w-2/3 h-2/3 bg-primary/5 rounded-2xl -z-20" />

            {}
            <img src="https://studiodclegal.it/wp-content/uploads/2026/03/tavolo3.png" alt="Studio Legale - Consulenza Professionale" className="w-full h-full object-cover rounded-xl shadow-xl border border-primary/10 bg-muted" />
            
            {}
            <div className="absolute bottom-8 left-8 bg-background/80 backdrop-blur-md border border-primary/20 p-6 rounded-lg shadow-lg max-w-[200px]">
              <p className="text-primary text-lg font-bold !font-sans">15+ Anni</p>
              <p className="text-xs text-muted-foreground uppercase tracking-widest font-medium">Di Eccellenza Legale</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}